import { decryptData, encryptData } from "config/config";
import { instance as axios, setMultiPartHeader } from "config/axiosInstance";
import { isLoggedIn } from "utils";

export const getCenters = async (data) => {
  return decryptData(
    await axios.get(
      `/centerbasedpage/list?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const addCenter = async (data) => {
  return decryptData(
    await axios.post(`/centerbasedpage/create`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const updateCenterStatus = async (data) => {
  return decryptData(
    await axios.get(
      `/centerbasedpage/change/status?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getSingleCenterById = async (data) => {
  return decryptData(
    await axios.get(
      `/centerbasedpage/view?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// ______________________________Mappings api of center based landing page__________________________________ //

// list of videos
export const getCenterVideoBanks = async (data) => {
  return decryptData(
    await axios.get(
      `/centerbasedpage/video?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// map detail video of center
export const mapCenterVideo = async (data) => {
  return decryptData(
    await axios.get(
      `/centerbasedpage/map/video/url?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// list of faq
export const getFAQBanks = async (data) => {
  return decryptData(
    await axios.get(
      `/centerbasedpage/faq?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// map faqs to center
export const mapFAQ = async (data) => {
  return decryptData(
    await axios.get(
      `/centerbasedpage/map/faq?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// list of billing course
export const getBillingCoursesForMapping = async (data) => {
  return decryptData(
    await axios.get(
      `/centerbasedpage/billingCourse?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// map billing course
export const mapBillingCourses = async (data) => {
  return decryptData(
    await axios.get(
      `/centerbasedpage/map/billing/course?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const mapGalleryImage = async (data) => {
  return decryptData(
    await axios.post(`/centerbasedpage/map/image`, data, setMultiPartHeader())
  );
};
